import { Suspense, useEffect } from "react";
import { useSession } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";

import { AuthCard } from "@/components/auth/auth-card";

export function SignupPage() {
  const { data: session, status } = useSession();
  const router = useRouter();
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") ?? "/";

  useEffect(() => {
    if (status === "authenticated") {
      if (session?.user?.role === "ADMIN") {
        router.replace(callbackUrl.startsWith("/admin") ? callbackUrl : "/admin");
      } else if (session?.user?.role === "ADMIN1") {
        router.replace(callbackUrl.startsWith("/admin1") ? callbackUrl : "/admin1");
      } else if (session?.user?.role === "VENDOR") {
        router.replace(callbackUrl.startsWith("/vendor") ? callbackUrl : "/vendor");
      } else {
        router.replace(callbackUrl);
      }
    }
  }, [status, session, router, callbackUrl]);

  return (
    <div className="relative min-h-[calc(100vh-140px)] w-full overflow-hidden bg-gradient-to-br from-slate-100 via-sky-50/20 to-slate-100 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex items-center justify-center px-3 sm:px-6 py-6 sm:py-8">
      {/* Ambient background glows */}
      <div className="pointer-events-none absolute -top-40 -left-40 h-96 w-96 rounded-full bg-[#087DB5]/10 blur-3xl dark:bg-[#087DB5]/5" />
      <div className="pointer-events-none absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-[#073B70]/10 blur-3xl dark:bg-[#073B70]/5" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(#073B70_1px,transparent_1px)] [background-size:24px_24px] opacity-[0.025] dark:opacity-[0.05]" />

      <div className="relative z-10 w-full flex justify-center">
        <Suspense fallback={null}>
          <AuthCard mode="signup" />
        </Suspense>
      </div>
    </div>
  );
}

